import { render, staticRenderFns } from "./invoice-item-detail.vue?vue&type=template&id=299dc924"
import script from "./invoice-item-detail.vue?vue&type=script&lang=js"
export * from "./invoice-item-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports